module.exports = __webpack_public_path__ + "assets/89259a73142ddf55017015bab98010d2.jpg";